var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "main-container",
      class: _vm.colorMode === "dark" ? "dark-block" : "",
    },
    [
      _c("h2", [
        _vm._v(
          "Deepening bankers’ visibility on bankable, private companies across the continent"
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Identifying new bankable prospects is a time-consuming data gathering exercise. Asoko proactively maps thousands of corporates across sectors and value-chains. We work with banks to turn this data-set into actionable lead lists, feeding directly into proprietary workflows."
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }